// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const PhysicalQuantity = {
  Unknown: "unknown",
  DigitalElevation: "digital_elevation",
  WaterLevel: "water_level",
  WaterDepth: "water_depth",
  WaterVelocity: "water_velocity",
  WaterArrivalTimes: "water_arrival_times",
  WaterRateOfRise: "water_rate_of_rise",
  WaterRisePeriod: "water_rise_period",
  Rain: "rain",
  Soil: "soil",
  Landuse: "landuse",
  Landcover: "landcover",
  Friction: "friction",
  Infiltration: "infiltration",
  WaterdepthDifference: "waterdepth_difference",
  ElevationDifference: "elevation_difference",
  FloodDuration: "flood_duration",
  LandUseChange: "land_use_change",
  LandUseGrouped: "land_use_grouped",
} as const;
export type PhysicalQuantity = (typeof PhysicalQuantity)[keyof typeof PhysicalQuantity];

export function instanceOfPhysicalQuantity(value: any): boolean {
  for (const key in PhysicalQuantity) {
    if (Object.prototype.hasOwnProperty.call(PhysicalQuantity, key)) {
      if (PhysicalQuantity[key as keyof typeof PhysicalQuantity] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PhysicalQuantityFromJSON(json: any): PhysicalQuantity {
  return PhysicalQuantityFromJSONTyped(json, false);
}

export function PhysicalQuantityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhysicalQuantity {
  return json as PhysicalQuantity;
}

export function PhysicalQuantityToJSON(value?: PhysicalQuantity | null): any {
  return value as any;
}

export function PhysicalQuantityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): PhysicalQuantity {
  return value as PhysicalQuantity;
}
